<template>
  <el-row :style="{'width': '100%', 'height': (dataList.length * 48) + 'px'}">
    <el-row v-for="(data, i) in dataList" :key="i" style="width: 100%;" class="sub-menu" @click.native="clickSub(data, i)">
      <el-row class="sub-menu-text">{{data.name}}</el-row>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'PopOverDown',
  props: ['parentData', 'dataList'],
  methods: {
    clickSub(data, i) {
      this.$emit('clickSub', data, i)
    }
  }
}
</script>

<style scoped>
  .sub-menu {
    text-align: left;
    height: 48px;
    line-height: 48px;
    width: 100%;
    border-bottom: 1px solid #e6e6e6;
    cursor: pointer;
  }
  .sub-menu:hover {
    background-color: #00bf86;
    color: #ffffff;
  }
  .sub-menu-text {
    text-align: left;
    width: 80%;
    margin-left: 20%;
  }
</style>



// WEBPACK FOOTER //
// src/components/PopOverDown.vue